<template lang="html">
  <div>
    <v-form
      ref="creationApprovalLevelForm"
      class="overflow"
      data-simplebar
    >
      <v-data-iterator
        :items="positions"
        :hide-default-footer="true"
        disable-pagination
        item-key="id"
      >
        <template>
          <v-row>
            <v-col
              v-for="(position,index) in positions"
              :key="index"
              cols="12"
              md="6"
            >
              <v-card class="mx-6">
                <v-card-title style="padding-top:0;padding-bottom:0;margin:0">
                  <span class="text-truncate title v-label theme--light pt-3">Position: {{ position.name }}</span>
                </v-card-title>

                <v-divider />
                <v-list
                  dense
                >
                  <v-list-item
                    class=""
                  >
                    <v-list-item-content
                      class="py-0"
                    >
                      Final Approver:
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-checkbox 
                        v-model="position.is_final_approver"
                      />
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-form>

    <v-container>
      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          @click="goPrevious"
        >
          Go back
        </v-btn>
        <v-btn
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loading: false,
        progressing: false,
        positions: [], 
      }
    },
    created () {
      this.loading = true
      this.loadData()
    },
    methods: {
      loadData () {
        this.$http.all([
          this.$api.positions().list(),
        ])
          .then(this.$http.spread((positions) => {
            this.positions = positions.data.map((position) => {
              return {
                id: position.id,
                name: position.name,
                is_final_approver: 0,
              }
            })

            this.loading = false
          }))
      },
      submitForm () {
        this.$emit('submit-form')
      },
      goPrevious () {
        this.$emit('previous-step')
      },
      getFormData () {
        return this.positions.map((position) => {
          return {
            id: position.id,
            is_final_approver: position.is_final_approver === true ? 1 : 0,
          }
        })
      },
      
    },
  }
</script>

<style lang='css' scoped>
  .overflow {
    height:50vh;
    overflow-x:hidden;
  }
  ::v-deep .centered-input input {
    text-align: center
  }
</style>
